import { Loader2 } from "lucide-react"

import { Logo } from "./logo"

/**
 * Loading component shown during route transitions
 * Prevents blank screens between navigation
 */
export function RouteLoading() {
  return (
    <div className="flex h-screen w-full items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <Logo size="lg" />
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-sm text-muted-foreground">Carregando...</p>
      </div>
    </div>
  )
}

/**
 * Minimal loading indicator for smaller transitions
 */
export function RouteLoadingMinimal() {
  return (
    <div className="flex w-full items-center justify-center p-8">
      <Loader2 className="h-6 w-6 animate-spin text-primary" />
    </div>
  )
}
